export default __webpack_public_path__ + "static/Concrete-Patio-Removal-d12748c01fc54f1fe5c4f81a727fee87.jpg";